import { DrawerDialog, DrawerDialogProps } from '@/common/components/drawer-dialog';
import Spacer from '@/common/components/spacer';
import { Button } from '@/shadcn-ui/button';
import { Link } from 'react-router';
import { referralTermsSupportUrl } from '../constants/support-urls';
import { PromoCodeReward } from '@/common/types/session';

interface PromoCodeModalProps extends DrawerDialogProps {
  reward: PromoCodeReward;
}

export default function PromoCodeModal({
  handleClose,
  open,
  reward,
}: PromoCodeModalProps) {
  const title =
    reward.type === 'mileage'
      ? `${reward.amount} free miles`
      : // NOTE: reward.amount comes back as negative for dollar promo codes
        `$${Math.abs(reward.amount)} off your order`;

  return (
    <DrawerDialog open={open} handleClose={handleClose} title={title}>
      {reward.type === 'mileage' ? (
        <>
          <ol className="list-outside list-decimal">
            <li>
              <p className="body-strong">Apply code and pick up vehicle</p>
              <p className="body">
                To receive the referral reward, you must apply your code at checkout and
                successfully pickup your vehicle.
              </p>
              <Spacer variant="height32" />
            </li>
            <li>
              <p className="body-strong">Receive {reward.amount} free miles</p>
              <p className="body">
                After you successfully complete pickup, {reward.amount} miles will be
                added to your account.
              </p>
              <Spacer variant={'height32'} />
              <p className="body">
                Any unused mileage credit rolls over to the next billing statement and is
                used to credit mileage charges only. This process continues until mileage
                credit is depleted. Mileage credit cannot be saved for future use and has
                no monetary value.
              </p>
              <Spacer variant={'height32'} />
              <div className="flex flex-row gap-[8px]">
                <p className="body">Participation subject to</p>

                <Link
                  className={'link-body'}
                  to={referralTermsSupportUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  Referral Program Terms
                </Link>
              </div>
            </li>
          </ol>
          <Spacer variant="height16" />
          <Button variant="primary" className={'w-full'} onClick={handleClose}>
            Close
          </Button>
        </>
      ) : (
        <>
          <p className="body">Your promo code has been successfully applied.</p>
          <ul className="list-outside">
            <li>
              {' '}
              <p className="body">
                <span className="body-strong">
                  ${Math.abs(reward.amount)} has been deducted
                </span>{' '}
                from your total at checkout.
              </p>
            </li>
            <li>
              <p className="body">
                This discount <span className="body-strong">cannot be combined</span> with
                other promo codes.
              </p>
            </li>
            <li>
              <p className="body">
                The discount{' '}
                <span className="body-strong">only applies to this order</span> and{' '}
                <span className="body-strong">will not roll over</span> to future
                invoices.
              </p>
            </li>
            <li>
              <p className="body">
                Your <span className="body-strong">updated total</span> is now reflected
                at checkout.
              </p>
            </li>
          </ul>
        </>
      )}
    </DrawerDialog>
  );
}
